// extracted by mini-css-extract-plugin
module.exports = {"container":"Submitted_container__fmrMb","title":"Submitted_title__19xxy","description":"Submitted_description__2Yltg"};